var map = {
	"./ion-action-sheet-ios.entry.js": [
		"8fxj",
		0,
		17
	],
	"./ion-action-sheet-md.entry.js": [
		"/NAp",
		0,
		18
	],
	"./ion-alert-ios.entry.js": [
		"v39o",
		0,
		19
	],
	"./ion-alert-md.entry.js": [
		"LO2T",
		0,
		20
	],
	"./ion-app_8-ios.entry.js": [
		"QHj0",
		0,
		21
	],
	"./ion-app_8-md.entry.js": [
		"qAXt",
		0,
		22
	],
	"./ion-avatar_3-ios.entry.js": [
		"0dZQ",
		0,
		23
	],
	"./ion-avatar_3-md.entry.js": [
		"KCJs",
		0,
		24
	],
	"./ion-back-button-ios.entry.js": [
		"alfR",
		0,
		25
	],
	"./ion-back-button-md.entry.js": [
		"U/jw",
		0,
		26
	],
	"./ion-backdrop-ios.entry.js": [
		"R/c5",
		27
	],
	"./ion-backdrop-md.entry.js": [
		"pA8c",
		28
	],
	"./ion-button_2-ios.entry.js": [
		"Msuq",
		0,
		29
	],
	"./ion-button_2-md.entry.js": [
		"u/MI",
		0,
		30
	],
	"./ion-card_5-ios.entry.js": [
		"lVNE",
		0,
		31
	],
	"./ion-card_5-md.entry.js": [
		"Gb/J",
		0,
		32
	],
	"./ion-checkbox-ios.entry.js": [
		"2YsE",
		0,
		33
	],
	"./ion-checkbox-md.entry.js": [
		"lSJ9",
		0,
		34
	],
	"./ion-chip-ios.entry.js": [
		"h+UY",
		0,
		35
	],
	"./ion-chip-md.entry.js": [
		"d14f",
		0,
		36
	],
	"./ion-col_3.entry.js": [
		"aoqT",
		37
	],
	"./ion-datetime_3-ios.entry.js": [
		"SV55",
		0,
		38
	],
	"./ion-datetime_3-md.entry.js": [
		"KqJa",
		0,
		39
	],
	"./ion-fab_3-ios.entry.js": [
		"QdBw",
		0,
		40
	],
	"./ion-fab_3-md.entry.js": [
		"wLS3",
		0,
		41
	],
	"./ion-img.entry.js": [
		"lYhy",
		42
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"W9z5",
		0,
		43
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"Osuu",
		0,
		44
	],
	"./ion-input-ios.entry.js": [
		"TW18",
		0,
		45
	],
	"./ion-input-md.entry.js": [
		"A3vp",
		0,
		46
	],
	"./ion-item-option_3-ios.entry.js": [
		"QSHf",
		0,
		47
	],
	"./ion-item-option_3-md.entry.js": [
		"Lc8E",
		0,
		48
	],
	"./ion-item_8-ios.entry.js": [
		"yJkF",
		0,
		49
	],
	"./ion-item_8-md.entry.js": [
		"nJbe",
		0,
		50
	],
	"./ion-loading-ios.entry.js": [
		"qfPd",
		0,
		51
	],
	"./ion-loading-md.entry.js": [
		"Voy3",
		0,
		52
	],
	"./ion-menu_3-ios.entry.js": [
		"Haxr",
		0,
		53
	],
	"./ion-menu_3-md.entry.js": [
		"XagV",
		0,
		54
	],
	"./ion-modal-ios.entry.js": [
		"0+Bq",
		0,
		55
	],
	"./ion-modal-md.entry.js": [
		"AF5P",
		0,
		56
	],
	"./ion-nav_2.entry.js": [
		"5E8l",
		0,
		57
	],
	"./ion-popover-ios.entry.js": [
		"ZG/G",
		0,
		58
	],
	"./ion-popover-md.entry.js": [
		"z0lq",
		0,
		59
	],
	"./ion-progress-bar-ios.entry.js": [
		"2YQO",
		0,
		60
	],
	"./ion-progress-bar-md.entry.js": [
		"qDED",
		0,
		61
	],
	"./ion-radio_2-ios.entry.js": [
		"IOpt",
		0,
		62
	],
	"./ion-radio_2-md.entry.js": [
		"Q4Z5",
		0,
		63
	],
	"./ion-range-ios.entry.js": [
		"t0+n",
		0,
		64
	],
	"./ion-range-md.entry.js": [
		"Hy4L",
		0,
		65
	],
	"./ion-refresher_2-ios.entry.js": [
		"ASjW",
		0,
		66
	],
	"./ion-refresher_2-md.entry.js": [
		"liZc",
		0,
		67
	],
	"./ion-reorder_2-ios.entry.js": [
		"aMvp",
		0,
		68
	],
	"./ion-reorder_2-md.entry.js": [
		"wCZP",
		0,
		69
	],
	"./ion-ripple-effect.entry.js": [
		"yNr1",
		70
	],
	"./ion-route_4.entry.js": [
		"EOjV",
		0,
		71
	],
	"./ion-searchbar-ios.entry.js": [
		"RXmo",
		0,
		72
	],
	"./ion-searchbar-md.entry.js": [
		"ffsq",
		0,
		73
	],
	"./ion-segment_2-ios.entry.js": [
		"Loa/",
		0,
		74
	],
	"./ion-segment_2-md.entry.js": [
		"hm+o",
		0,
		75
	],
	"./ion-select_3-ios.entry.js": [
		"kxfy",
		0,
		76
	],
	"./ion-select_3-md.entry.js": [
		"RRhw",
		0,
		77
	],
	"./ion-slide_2-ios.entry.js": [
		"MyoC",
		78
	],
	"./ion-slide_2-md.entry.js": [
		"pKl9",
		79
	],
	"./ion-spinner.entry.js": [
		"4RuT",
		0,
		80
	],
	"./ion-split-pane-ios.entry.js": [
		"8LTB",
		81
	],
	"./ion-split-pane-md.entry.js": [
		"zG3r",
		82
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"ri6M",
		0,
		83
	],
	"./ion-tab-bar_2-md.entry.js": [
		"3xPB",
		0,
		84
	],
	"./ion-tab_2.entry.js": [
		"ZyW4",
		0,
		85
	],
	"./ion-text.entry.js": [
		"7Ttm",
		0,
		86
	],
	"./ion-textarea-ios.entry.js": [
		"bRvG",
		0,
		87
	],
	"./ion-textarea-md.entry.js": [
		"RoCC",
		0,
		88
	],
	"./ion-toast-ios.entry.js": [
		"W9p6",
		0,
		89
	],
	"./ion-toast-md.entry.js": [
		"XCFn",
		0,
		90
	],
	"./ion-toggle-ios.entry.js": [
		"ba+K",
		0,
		91
	],
	"./ion-toggle-md.entry.js": [
		"ro3r",
		0,
		92
	],
	"./ion-virtual-scroll.entry.js": [
		"X9e5",
		93
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Bf66";
module.exports = webpackAsyncContext;